"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import posthog from "posthog-js";

/**
 * Session replay ONLY on the Zenyra chat — that's the single surface where
 * the conversion drop-off (chat → gate → signup) is hard to understand from
 * numbers alone. Everywhere else (/teste, /gaseste-terapeut, blog, home, etc.)
 * funnels alone are sufficient because the steps are obvious and clickable.
 * This keeps replays well within the free tier (~5K/month) at ~1000 daily
 * visitors.
 */
const RECORD = [
  /^\/zenyra(\/|$|\?)/, // AI chat → recommendation → gate
  // Temporary, until ~2026-10-16: the two ad landing pages, to see why ~40%
  // of visitors leave without opening a second page (most never scroll past
  // the first screen). About 190 sessions a week, well inside the free tier.
  /^\/$/,
  /^\/sesiune-cunoastere\/?$/,
];

/**
 * Surgical session-replay control. The init sets `disable_session_recording`
 * to true; this hook toggles it on per matched route and off everywhere else.
 * Existing recordings keep playing through the rest of the session if the
 * user navigates away — that's fine and gives us the full drop-off trail.
 */
export default function PosthogRouteGuard() {
  const pathname = usePathname();

  useEffect(() => {
    if (!pathname) return;
    const shouldRecord = RECORD.some((re) => re.test(pathname));
    try {
      if (shouldRecord) {
        posthog.startSessionRecording();
      } else {
        posthog.stopSessionRecording();
      }
    } catch {
      /* posthog not initialized */
    }
  }, [pathname]);

  return null;
}
